/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_sip_compound_nav = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compound Interest`)
};

const es_sip_compound_nav = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interés Compuesto`)
};

const de_sip_compound_nav = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zinseszins`)
};

const nl_sip_compound_nav = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Samengestelde rente`)
};

const fr_sip_compound_nav = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intérêt Composé`)
};

const it_sip_compound_nav = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interesse Composto`)
};

const pt_br2_sip_compound_nav = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juros Compostos`)
};

const pt_sip_compound_nav = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juro Composto`)
};

const ja_sip_compound_nav = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`複利計算`)
};

const zh_sip_compound_nav = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`复利计算`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const sip_compound_nav = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.sip_compound_nav(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("sip_compound_nav", locale)
	if (locale === "en") return en_sip_compound_nav(inputs)
	if (locale === "es") return es_sip_compound_nav(inputs)
	if (locale === "de") return de_sip_compound_nav(inputs)
	if (locale === "nl") return nl_sip_compound_nav(inputs)
	if (locale === "fr") return fr_sip_compound_nav(inputs)
	if (locale === "it") return it_sip_compound_nav(inputs)
	if (locale === "pt-BR") return pt_br2_sip_compound_nav(inputs)
	if (locale === "pt") return pt_sip_compound_nav(inputs)
	if (locale === "ja") return ja_sip_compound_nav(inputs)
	return zh_sip_compound_nav(inputs)
};